<template>
  <div class="payment">
    <NavBar></NavBar>
    <div class="pay-banner">
      <div style="font-weight:bold">支付详情</div>
      <br />
      <i class="iconfont icon-fangzi-1" />&nbsp;&nbsp;
      <span>{{room}}</span>
    </div>
    <div class="pay-content">
      <div class="titel" style="">费用详情</div>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa' }"></van-divider>
      <!-- <div class="pay-details">
        <van-col span="24" class="pay-text">
          <i class="iconfont icon-yezhu" />  业主余额 ：<span style="color:#f00"> ￥ {{balance}}</span>
        </van-col>
        <van-col span="24" class="pay-text">
          <i class="iconfont icon-heji" />  费用合计 ：<span style="color:#f00"> ￥ {{totalCost}}</span>
        </van-col>
        <van-col span="24" class="pay-text">
          <i class="iconfont icon-jiaofei" />  应缴费用 ：<span style="color:#f00"> ￥ {{feesPayable}}</span>
        </van-col>
      </div> -->
      <!--  -->
      <van-collapse v-model="activeNames" class="coolapse">
        <van-collapse-item title="应缴费用" name="1" icon="balance-o" :value="'￥'+feesPayable">
          <!-- <van-cell-group class="clloapseSon"> -->
            <div class="clloapseSon">
              <van-cell :border='false' title="费用合计" :value="'￥'+totalCost" />
              <van-cell :border='false' title="业主余额" :value="'￥'+balance" />
            </div>
          <!-- </van-cell-group> -->
        </van-collapse-item>
      </van-collapse>
      <!--  -->
    </div>
    <van-col span='24' style="margin-bottom:10px;padding:0px 10px;position: fixed;bottom:0;left:0;right:0;">
      <van-button type="danger" size="normal" block @click="payment">立即支付(￥{{feesPayable}})</van-button>
    </van-col>
  </div>
</template>
<script>
import VueCookie from 'vue-cookie'
export default {
  data() {
    return {
      activeNames:['1'],
      appId:'',
      nonceStr:'',
      package:'',
      paySign:'',
      signType:'',
      timeStamp:'',
      //
      feeIds:[],
      houseguid:'',
      room:"",
      balance:"",
      feesPayable:"",
      totalCost:""
    };
  },
  methods: {
    payment(){
      if(this.feesPayable==0){
          this.$toast('余额足够，请联系物业公司抵扣！')
      }else{
          let data={
              houseId:this.houseguid
          } 
          this.$postQuery('/RegionInfo/getPayTime', data).then((response) => {
              // console.log(response)
              if(response.code==200){
                  this.payMoney()
              }else{
                  this.$toast(response.data)
              }
          })
      }
    },
    payMoney(){
      let data={
          houseguid:this.houseguid,
          openId:VueCookie.get('openId'),
          amount:parseFloat(this.feesPayable),
          feeIds:this.feeIds,
          payReason:2
      }
      this.$postJson('/FeeRecord/createOrder', data).then((response) => {
          console.log(response)
          if(response.code==200){
              this.appId=response.data.appId
              this.nonceStr=response.data.nonceStr
              this.package=response.data.package
              this.paySign=response.data.paySign
              this.signType=response.data.signType
              this.timeStamp=response.data.timeStamp

              var _this=this;
              if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                      document.addEventListener('WeixinJSBridgeReady', _this.imatePay(), false);
                  } else if (document.attachEvent) {
                      document.attachEvent('WeixinJSBridgeReady', _this.imatePay());
                      document.attachEvent('onWeixinJSBridgeReady', _this.imatePay());
                  }
              } else {
                  _this.imatePay()
              }
          }else{
            // this.$toast(response.data)
            this.$toast('操作失败')
          }
      })

    },
    imatePay(){
        var _this=this;
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
            appId:_this.appId,     //公众号ID，由商户传入     
            timeStamp:_this.timeStamp,     //时间戳，自1970年以来的秒数     
            nonceStr:_this.nonceStr,      //随机串     
            package:_this.package,
            signType:_this.signType,     //微信签名方式：
            paySign:_this.paySign, //微信签名 
        },
        function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                // _this.$router.replace({
                //     path:'/'
                // })
                // window.location.href('')
                window.location.href('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe95b8bf597bd4f05&redirect_uri=https%3A%2F%2Fpdxs.sdcskj.cn%2F%23%2F&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
            }else{
              _this.$router.push('/')
            }
        })
    }
  },
  created: function () {
    this.room = this.$route.query.room;
    this.balance = this.$route.query.balance;
    this.feesPayable = this.$route.query.feesPayable;
    this.totalCost = this.$route.query.totalCost;
    this.houseguid = this.$route.query.houseguid
    this.feeIds = this.$route.query.feeIds
  }
};
</script>
<style scoped>
  .payment{
    margin: 46px 10px 0;
  }
  .pay-banner{
    padding: 50px 0;
    font-size: 18px;
    text-align: center;
    background-image: url('../../assets/Image/house-banner.png');
    background-repeat:no-repeat;
    background-position:center;
    background-size: auto 100%;
    border-radius: 4px;
    color:#fff;
  }
  .iconfont{
    font-size: 22px;
  }
  .pay-content .titel{
    text-align:left;
    font-size:14px;
    padding-top:20px;
    font-weight:bold;
    /* padding-left:5%; */
    color:rgb(52, 159, 235);
  }
  .pay-details{
    width: 80%;
    margin: 30px auto;
    font-weight: bold;
  }
  .pay-text{
    margin-bottom: 24px;
  }
  .pay-button{
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .coolapse>>>.van-cell__value{
    color: red;
    font-size: 16px;
  }
  .clloapseSon>>>.van-cell__value{
    color: rgb(43, 41, 41);
    font-size: 13px;
  }
</style>